import { gql } from '@common/hooks';
import {
  InvoiceListItemFragment,
  InvoiceListItemFragmentType,
  InvoiceStateType,
  InvoiceReviewFragment,
  InvoiceReviewFragmentType,
} from '@pay-bill/graphql/fragments';
import { HistoryInfoFragment } from '@common/graphql';

export const PaginatedInvoicesQuery = gql`
  query PaginatedInvoicesQuery(
    $limit: Int!
    $offset: Int!
    $orderDirection: OrderDirection
    $orderField: WorksInvoiceOrderField
    $filters: WorksInvoiceFilterInput
  ) {
    paginatedWorksInvoices(
      limit: $limit
      offset: $offset
      orderDirection: $orderDirection
      orderField: $orderField
      filters: $filters
    ) {
      totalCount
      worksInvoices {
        ...InvoiceListItemFragment
      }
    }
  }
  ${InvoiceListItemFragment}
`;

export type PaginatedInvoicesQueryResponse = {
  paginatedWorksInvoices: {
    totalCount: number;
    worksInvoices: InvoiceListItemFragmentType[];
  };
};

export type PaginatedInvoicesQueryArgs = {
  limit: number;
  offset: number;
  orderDirection: 'ASC' | 'DESC';
  orderField:
    | 'BILLING_AMOUNT'
    | 'CREATED_AT'
    | 'ID' // TODO: rename to code
    | 'PAY_PERIOD'
    | 'STATE'
    | 'SUPPLIERS';
  filters: {
    code?: string[];
    date?: string[];
    states?: InvoiceStateType[];
    suppliers?: string[];
  };
};

export const InvoiceFiltersQuery = gql`
  query WorksInvoiceFilters {
    worksInvoiceFilters {
      states
      suppliers {
        id
        name
      }
    }
  }
`;

export type InvoiceFiltersQueryResponse = {
  worksInvoiceFilters: {
    states: InvoiceStateType[];
    suppliers: { id: string; name: string }[];
  };
};

export const InvoiceReviewQuery = gql`
  query GetWorksInvoice($id: String!) {
    worksInvoice(id: $id) {
      ...InvoiceReviewFragment
    }
  }
  ${InvoiceReviewFragment}
`;

export type InvoiceReviewQueryResponse = {
  worksInvoice: InvoiceReviewFragmentType;
};

export type InvoiceReviewQueryArgs = {
  id: string;
};

export const InvoiceHoursTab = gql`
  query InvoiceHoursTab($id: String!) {
    worksInvoice(id: $id) {
      id
      disputeClosingDate
      canSubmitDispute {
        value
      }
    }
  }
`;

export const InvoiceHistoryTab = gql`
  query InvoiceHistoryTab($id: String!) {
    worksInvoice(id: $id) {
      id
      history {
        ...HistoryInfoFragment
      }
    }
  }
  ${HistoryInfoFragment}
`;
